import React, { useEffect, useState } from "react";
import { Button } from "reactstrap";

// import './Menu.css'
import { toast } from "react-hot-toast";

export const SelectedModal = ({ data, defaultImg }) => {
  const calculateDiscountedPrice = () => {
    const price = data.price;
    const discount = data.discountDetail?.discountPercentage || 0;
    return price - (price * discount) / 100;
  };

  return (
    <div className="">
      <div className="text-center menu-item-detail-pos mb-3 ">
        <img
          src={data?.cloudR2ImagePath?.getCDNUrl() || defaultImg}
          alt={data?.title}
          className="img-fluid"
        />
      </div>
      <div className="mb-3">
        <h6 className="">{data?.title}</h6>
        <h4 className="fw-bold">
          {" "}
          <span>
            <i class="ri-map-pin-line"></i>
          </span>{" "}
          {data?.restaurantName}
        </h4>
        <hr/>
        <p className="text-muted">
          {data.description || "No description available."}
        </p>
      </div>

      <div className="mb-3  d-flex justify-content-between">
        <div>
          {data.discountDetail && (
            <p className="mb-1 text-muted">
              <span className="fw-bold ">Original Price:</span> Rs. {data.price}
            </p>
          )}
          {data.discountDetail && (
            <p className="mb-1 text-danger">
              <span className="fw-bold">Discount:</span>{" "}
              {data.discountDetail.discountPercentage}% OFF
            </p>
          )}
          <p className="mb-1">
            <span className="fw-bold">Price:</span> Rs.{" "}
            {calculateDiscountedPrice()}
          </p>
        </div>

        <div></div>
      </div>

      {/* <div className="d-flex align-items-center gap-3 mb-3">
        <Button color="light" size="sm" onClick={handleDecrement}>
          -
        </Button>
        <span className="fw-bold">{localQuantity}</span>
        <Button color="light" size="sm" onClick={handleIncrement}>
          +
        </Button>
      </div> */}

      {/* <div className="mb-3">
        <p className="fw-bold">Total Price: Rs. {calculateTotalPrice()}</p>
      </div>
      <div className="text-center ">
        <Button
          color="primary"
          size="lg"
          className="w-100"
          onClick={handlePlaceOrder}
          disabled={loading}
        >
          {loading ? "Adding Order..." : "Add Order"}
        </Button>
        {error && <p className="text-danger mt-2">{error}</p>}
      </div> */}
    </div>
  );
};
